import Wahanda from 'common/wahanda';
import { isFeatureEnabled } from 'common/trunk-features/store/selectors';

// The flag string keeps its original name: it is already configured per channel,
// and renaming a live trunk feature costs a config change everywhere for no
// user-visible gain. The page it gates is the Appointment Message Log.
export const APPOINTMENT_MESSAGE_LOG_FEATURE = 'THY-2357-confirmation-email-log';

/**
 * The Appointment message log is gated on the story's feature flag plus the
 * three permissions its endpoint asserts — `MessageLogController` in
 * connect-services calls `assertHasVenuePermission` for `access-marketing-tools`,
 * `view-client-contact-details` and `view-client-list`, and throws on the first
 * one missing.
 *
 * All three are checked here so the nav item is hidden rather than leading to a
 * page that loads and then fails: a user holding only some of them would
 * otherwise see the table's generic "we couldn't load your message history"
 * error and have no way to tell it was a permission problem.
 *
 * `access-marketing-tools` is already required to reach the Marketing section at
 * all (see `index.tsx`), so it is redundant in practice — kept explicit so this
 * check and the endpoint's can be compared line for line.
 *
 * The page's resend action needs nothing further: that route asserts only
 * `assertHasVenueAccess`, so anyone who passes this gate can already use it.
 *
 * Lives in its own module so the sidebar container and the router container can
 * share it without importing each other.
 */
export const isAppointmentMessageLogAccessible = (state): boolean =>
  isFeatureEnabled(state, APPOINTMENT_MESSAGE_LOG_FEATURE) &&
  Wahanda.Permissions.canAccessMarketingTools() &&
  Wahanda.Permissions.viewClientContactDetails() &&
  Wahanda.Permissions.viewClientList();
